import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NgxCsvParser } from 'ngx-csv-parser';

@Injectable({
  providedIn: 'root',
})
export class SeedDataService {
  seedData: any[] = [];

  constructor(private http: HttpClient, private ngxCsvParser: NgxCsvParser) {}

  getSeedData(csvPath?: string, imagePath?: string) {
    const path = csvPath ? csvPath : 'assets/data/seed-data.csv';
    const imgpath = imagePath ? imagePath : 'assets/img/seed';

    return this.http.get(path, { responseType: 'text' }).pipe(
      map(data => {
        const rows: string[][] = this.ngxCsvParser.csvStringToArray(data, ',');
        for (const row of rows.filter(r => r && r[0])) {
          // 語言, Seed Tec 編號, 中文名, 英文名, 學名, 類別, 科, 品種, 品種特性, 作物特點, 種植季節, 種植技術, 分子標記資料, 種子產地

          if (this.seedData.findIndex(s => s.code === row[1].trim()) === -1) {
            const tmp = {
              code: row[1].trim(),
              nameTc: '',
              nameSc: '',
              nameEn: '',
              sciName: '', // 學名
              catTc: '',
              catSc: '',
              catEn: '',
              branchTc: '', // 科
              branchSc: '',
              branchEn: '',
              breedTc: '', // 品種
              breedSc: '',
              breedEn: '',
              varietyTc: '', // 品種特性
              varietySc: '',
              varietyEn: '',
              cropTc: '', // 作物特點
              cropSc: '',
              cropEn: '',
              seasonTc: '', // 種植季節
              seasonSc: '',
              seasonEn: '',
              season2SearchTc: '', // 種植季節 Search
              season2SearchSc: '',
              season2SearchEn: '',
              techTc: '', // 種植技術
              techSc: '',
              techEn: '',
              markerTc: '', // 分子標記資料
              markerSc: '',
              markerEn: '',
              originTc: '', // 種子產地
              originSc: '',
              originEn: '',
              images: [],
            };

            let maxNoOfImages: number = +row[15]?.trim();
            if (!maxNoOfImages) {
              maxNoOfImages = 2;
            }

            if (true) {
              let i = 1;
              do {
                const imageUrl = `${imgpath}/${tmp.code}_${i}.jpg`;
                tmp.images.push(imageUrl);

                // let defaultUrl = '';
                // if (i < 3) {
                //   defaultUrl = 'https://via.placeholder.com/600x300?text=SeedTEC';
                // }

                // const exists = this.doesFileExist(imageUrl);
                // if (exists) {
                //   tmp.images.push(imageUrl);
                // } else {
                //   if (defaultUrl) {
                //     tmp.images.push(defaultUrl);
                //   }
                //   break;
                // }

                i++;
              } while (i <= maxNoOfImages);
            }

            // const img1path = `${imgpath}/${tmp.code}_1.jpg`;
            // imageExists(img1path, exists => tmp.images.push(exists ? `${img1path}` : 'https://via.placeholder.com/600x300?text=SeedTEC'));

            // const img2path = `${imgpath}/${tmp.code}_2.jpg`;
            // imageExists(img2path, exists => tmp.images.push(exists ? `${img2path}` : 'https://via.placeholder.com/600x300?text=SeedTEC'));

            // tmp.images.sort();

            this.seedData.push(tmp);
          }

          const idx = this.seedData.findIndex(s => s.code === row[1].trim());
          this.seedData[idx].sciName = row[4].trim();

          switch (row[0].trim().toUpperCase()) {
            case '繁體':
              this.seedData[idx].nameTc = row[2].trim();
              this.seedData[idx].catTc = row[5].trim();
              this.seedData[idx].branchTc = row[6].trim();
              this.seedData[idx].breedTc = row[7].trim();
              this.seedData[idx].varietyTc = row[8].trim();
              this.seedData[idx].cropTc = row[9].trim();
              this.seedData[idx].seasonTc = row[10].trim();
              this.seedData[idx].season2SearchTc = row[11].trim();

              // this.seedData[idx].techTc = row[11].trim();
              // this.seedData[idx].markerTc = row[12].trim();
              // this.seedData[idx].originTc = row[13].trim();
              this.seedData[idx].techTc = row[12].trim();
              this.seedData[idx].markerTc = row[13].trim();
              this.seedData[idx].originTc = row[14].trim();
              break;
            case '简体':
              this.seedData[idx].nameSc = row[2].trim();
              this.seedData[idx].catSc = row[5].trim();
              this.seedData[idx].branchSc = row[6].trim();
              this.seedData[idx].breedSc = row[7].trim();
              this.seedData[idx].varietySc = row[8].trim();
              this.seedData[idx].cropSc = row[9].trim();
              this.seedData[idx].seasonSc = row[10].trim();
              this.seedData[idx].season2SearchSc = row[11].trim();

              // this.seedData[idx].techSc = row[11].trim();
              // this.seedData[idx].markerSc = row[12].trim();
              // this.seedData[idx].originSc = row[13].trim();
              this.seedData[idx].techSc = row[12].trim();
              this.seedData[idx].markerSc = row[13].trim();
              this.seedData[idx].originSc = row[14].trim();
              break;
            case 'ENG':
              this.seedData[idx].nameEn = row[2].trim();
              this.seedData[idx].catEn = row[5].trim();
              this.seedData[idx].branchEn = row[6].trim();
              this.seedData[idx].breedEn = row[7].trim();
              this.seedData[idx].varietyEn = row[8].trim();
              this.seedData[idx].cropEn = row[9].trim();
              this.seedData[idx].seasonEn = row[10].trim();
              this.seedData[idx].season2SearchEn = row[11].trim();

              // this.seedData[idx].techEn = row[11].trim();
              // this.seedData[idx].markerEn = row[12].trim();
              // this.seedData[idx].originEn = row[13].trim();
              this.seedData[idx].techEn = row[12].trim();
              this.seedData[idx].markerEn = row[13].trim();
              this.seedData[idx].originEn = row[14].trim();
              break;
          }
        }
        return this.seedData;
      }),
    );
  }

  doesFileExist(urlToFile) {
    var xhr = new XMLHttpRequest();
    xhr.open('HEAD', urlToFile, false);
    xhr.send();
    const res = xhr.status === 404 ? false : true;

    xhr.abort();
    return res;
  }
}
